export const createConsumableBuffer = <T>(initial?: T[]) => {
    const EMPTY_ARRAY: T[] = [];
    const buffer = new Set<T>(initial);

    return Object.freeze({
        push(value: T) {
            buffer.add(value);
        },
        /**
         * Consume the buffer
         */
        consume() {
            if (buffer.size === 0) {
                return EMPTY_ARRAY;
            }
            const result = Array.from(buffer.values());
            buffer.clear();
            return result;
        },
        /**
         * get everything from the buffer without modifying it
         */
        dump() {
            return Array.from(buffer);
        },
        any() {
            return Boolean(buffer.size);
        },
        clear() {
            buffer.clear();
        },
    });
};
